import React from 'react';
import { Helmet } from "react-helmet";
import ReactGA from 'react-ga';
import { Grid } from 'antd';
import PaymentMethodDesktop from './Desktop';
import PaymentMethodMobile from './Mobile';
const { useBreakpoint } = Grid;

function GetBreakPoint() {
  const screens = useBreakpoint()
  return screens;
}

export default function XpertDetail(props) {
  const { lg } = GetBreakPoint()

  if(process.env.REACT_APP_ENV === "production"){
    ReactGA.pageview(`${window.location.pathname}${window.location.search}`, [], 'Xpert - Payment Method');
  }

  return (
    <React.Fragment>
      <Helmet>
        <title>Xpert - Payment Method</title>
      </Helmet>
      {
        lg ?
          <PaymentMethodDesktop {...props} />
        :
          <PaymentMethodMobile {...props} />
      }
    </React.Fragment>
  )
}